/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/tahsil-request',
  name: 'tahsilRequest',
  component: () => import('@/views/tahsil/Request'),
},
{
  path: '/tahsil-history',
  name: 'tahsilHistory',
  component: () => import('@/views/tahsil/Index'),
}
]

